module.exports = __webpack_public_path__ + "static/swan-gardens.d422987f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/swan-gardens.jpg
// module id = 633
// module chunks = 262104617495404